import { Typography } from '@mui/material';
import { t } from 'i18next';
import { Column } from '../../../components';

interface AtAGlanceSectionProps {
  bullets: React.ReactNode[];
}

const AtAGlanceSection: React.FC<AtAGlanceSectionProps> = ({ bullets }) => {
  return (
    <>
      <Typography color='secondary' variant='p18Bold'>
        {t('AtAGlance...')}
      </Typography>
      <Column style={{ width: '85%', marginTop: '20px', gap: '20px' }}>
        {bullets.map((bullet) => bullet)}
      </Column>
    </>
  );
};

export default AtAGlanceSection;
